import { useState } from 'react';
import { adminLLMApi } from '../../../services/api/admin';

interface SavePresetModalProps {
  isOpen: boolean;
  onClose: () => void;
  systemPrompt: string;
  fakeConversation: string;
  onSaved: () => void;
}

export function SavePresetModal({
  isOpen,
  onClose,
  systemPrompt,
  fakeConversation,
  onSaved,
}: SavePresetModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async () => {
    if (!name.trim()) {
      setError('請輸入名稱');
      return;
    }

    let parsedFakeConversation;
    try {
      parsedFakeConversation = JSON.parse(fakeConversation);
    } catch {
      setError('Fake Conversation JSON 格式錯誤');
      return;
    }

    try {
      setIsSaving(true);
      setError(null);

      await adminLLMApi.createJailbreakPreset({
        name: name.trim(),
        description: description.trim() || undefined,
        system_prompt: systemPrompt,
        fake_conversation: parsedFakeConversation,
      });

      setName('');
      setDescription('');
      onSaved();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save preset');
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="overlay" onClick={onClose} />
      <div className="modal-content max-w-md">
        <div className="card-header">
          <h3 className="heading-card text-neutral-900 dark:text-neutral-50">
            儲存 Preset
          </h3>
        </div>
        <div className="card-body space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
              名稱 *
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="例如：Dr-n v8.0 強化版"
              className="input w-full"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
              描述
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="簡短說明此 Preset 的用途..."
              rows={3}
              className="textarea w-full"
            />
          </div>
          <div className="p-3 bg-neutral-100 dark:bg-neutral-700 rounded text-xs text-neutral-600 dark:text-neutral-400">
            <p>
              <strong>System Prompt:</strong> {systemPrompt.slice(0, 100)}...
            </p>
            <p className="mt-1">
              <strong>Fake Conversation:</strong> {fakeConversation.slice(0, 100)}...
            </p>
          </div>
          {error && (
            <div className="p-2 bg-danger-50 dark:bg-danger-900/20 text-danger-700 dark:text-danger-300 rounded text-sm">
              {error}
            </div>
          )}
        </div>
        <div className="card-footer flex justify-end gap-2">
          <button onClick={onClose} className="btn btn-ghost btn-sm">
            取消
          </button>
          <button
            onClick={handleSave}
            disabled={isSaving}
            className="btn btn-primary btn-sm"
          >
            {isSaving ? '儲存中...' : '儲存'}
          </button>
        </div>
      </div>
    </div>
  );
}
